import { ConstantsMobile, PagePathMobile } from '@/mobile/utils/constants';
import alertGlobalState from '@/states/alertGlobalState';
import { Constants } from '@/utils/constants';
import Router from 'next/router';
import { useRecoilState } from 'recoil';
import useServiceType from './useServiceType';

/**
 * API呼出し時の共通エラー処理
 * @returns API呼出し時の共通エラー処理実行関数
 */
const useCommonApiErrorHandling = () => {
  const [alertGlobal, setAlertGlobal] = useRecoilState(alertGlobalState);
  const serviceType = useServiceType();

  /**
   * API呼出し時の共通エラー処理
   * @description
   * - ログイントークンの有効期限が切れている場合、ログイン画面に遷移
   * - APIのステータスコードが503の場合、メンテナンスダイアログを表示
   * - システムエラーダイアログを表示（料金・お知らせ画面への遷移有無を選択可能）
   * @param params
   * @param params.error catchのエラー
   * @param params.isTransitionTop 各サービスのTOP画面への遷移有無（デフォルト：false）
   */
  const commonErrorHandling = ({
    error,
    isTransitionTop = false,
  }: {
    error: any;
    isTransitionLogin?: boolean;
    isTransitionTop?: boolean;
  }) => {
    // メンテナンスダイアログ表示
    if (error.response?.status === 503) {
      // メンテナンス時は通常のエラーダイアログではなく専用文言を優先する。
      setAlertGlobal({
        ...alertGlobal,
        isOpen: true,
        message: Constants.ErrorDialogMessage.MAINTENANCE,
      });
      return;
    }

    let closeAction = () => {};

    if (isTransitionTop) {
      // 復帰先をサービス別TOPへ固定し、エラー後に行き止まりにならないようにする。
      if (serviceType === 'fixed' && Router.asPath !== '/top/')
        closeAction = () => {
          Router.push('/top/');
        };
      if (serviceType === 'mobile' && Router.asPath !== PagePathMobile.top)
        closeAction = () => {
          Router.push(PagePathMobile.top);
        };
    }

    // システムエラーダイアログ表示
    setAlertGlobal({
      isOpen: true,
      message: Constants.ErrorDialogMessage.DEFAULT,
      type: '',
      closeAction,
    });
  };

  /**
   * API呼出し時のresponse_codeエラー共通処理
   * @description
   * - bad requestの場合、システムエラーダイアログを表示（料金・お知らせ画面への遷移有無を選択可能）
   * @param params
   * @param params.responseCode レスポンスコード
   * @param params.isTransitionTop 各サービスのTOP画面への遷移有無（デフォルト：false）
   * @returns エラー有無
   */
  const commonResponseCodeHandling = ({
    responseCode,
    isTransitionTop = false,
  }: {
    responseCode: string;
    isTransitionTop?: boolean;
  }) => {
    if (responseCode === ConstantsMobile.ResponseCode.BAD_REQUEST) {
      let closeAction = () => {};

      if (isTransitionTop) {
        // 業務エラー後も利用者が戻り先を失わないよう、閉じる操作にTOP遷移を紐づける。
        if (serviceType === 'fixed' && Router.asPath !== '/top/')
          closeAction = () => {
            Router.push('/top/');
          };
        if (serviceType === 'mobile' && Router.asPath !== PagePathMobile.top)
          closeAction = () => {
            Router.push(PagePathMobile.top);
          };
      }

      // システムエラーダイアログ表示
      setAlertGlobal({
        isOpen: true,
        message: Constants.ErrorDialogMessage.DEFAULT,
        type: '',
        closeAction,
      });

      return { isError: true };
    }

    return { isError: false };
  };

  return { commonErrorHandling, commonResponseCodeHandling };
};

export default useCommonApiErrorHandling;
